<div class="card">
  <app-header titulo="Busca Nota Fiscal" descricao="Busca de notas fiscais anteriores ou já integradas."></app-header>

  <div class="flex flex-row flex-wrap mt-3">
    <div class="flex ml-1 xl:mt-1">
      <p-floatLabel>
        <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" modo="unico"/>
        <!-- <p-dropdown
          appendTo="body"
          [options]="instancias"
          [style]="{'width':'200px'}"
          optionValue="id"
          optionLabel="nome"

          [(ngModel)]="instanciaSelecionada"
          dataKey="id" inputId="id"
          placeholder="Instância"
          emptyMessage="Nenhuma instância"
          id="instancia">

        </p-dropdown > -->
        <!-- <label for="instancia">Instância</label> -->
      </p-floatLabel>
    </div>
    <div class="flex ml-1 xl:mt-1">
      <p-floatLabel>
        <p-calendar
          id="dataCompetencia"
          [(ngModel)]="dataCompetencia"
          selectionMode="single"
          dateFormat="mm/yy"
          view="month"
          [readonlyInput]="true"
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="icondisplay"
        />
        <label for="dataCompetencia">Data Competência</label>
      </p-floatLabel>
    </div>
    <div class="flex ml-1 xl:mt-1">
      <p-floatLabel>
        <input pInputText id="notafiscal" type="text" [(ngModel)]="notafiscal" (keydown.enter)="buscarNotaFiscal()" >
        <label for="notafiscal">Número Nota</label>
      </p-floatLabel>
    </div>
    <div class="flex ml-1 xl:mt-1">
      <button pButton pRipple icon="pi pi-arrow-down-right" (click)="buscarNotaFiscal()" label="Buscar"
              [loading]="loadingSincronizar" [disabled]="loading"></button>
    </div>
    <div class="flex ml-1 xl:mt-1">
      <button pButton pRipple icon="pi pi-download" (click)="exportar()" label="Exportar"
              [loading]="loadingSincronizar" [disabled]="loading"></button>
    </div>
<!--    <div class="flex ml-1 xl:mt-1">-->
<!--      <button pButton pRipple icon="pi pi-file-excel" (click)="exportar()" label="Exportar"-->
<!--              [loading]="loadingSincronizar" [disabled]="loading"></button>-->
<!--    </div>-->
  </div>

  <p-table [value]="notasfiscais" dataKey="notafiscal" #dt [loading]="loading"
           [globalFilterFields]="['deProcesso','instancia', 'noNfPims', 'cdFornecErp','vlLiquido','valorTaxa','fazenda']"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines mt-5"
           [scrollable]="true"
           scrollHeight="40.5rem">
    <ng-template pTemplate="emptymessage">
      <td colspan="21">Nenhum registro</td>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="text-center">
        <th colspan="9">Original</th>
        <th colspan="4">Ajustar</th>
      </tr>
      <tr class="text-center">
        <th>Instância</th>
        <th>Competência</th>
        <th>Nº NF PIMS</th>
        <th>Nº NF ERP</th>
        <th>Cód ERP</th>
        <th>Razão Social</th>
        <th>Cód Fazenda</th>
        <th>Fazenda</th>
        <th>Valor</th>
        <th>Data Emissão</th>
        <th>Cód ERP</th>
        <th>Razão Social</th>
        <th>Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-notafiscal >
      <tr class="text-sm">
        <td><b>{{notafiscal.instancia}}</b></td>
        <td>{{notafiscal.dtCompetencia | date: 'MM/yyyy' }}</td>
        <td>{{notafiscal.noNf}}</td>
        <td><span class="text-red-500">{{notafiscal.noNfErp || ''}}</span></td>
        <td>{{notafiscal.cdFornecErp}}</td>
        <td>{{notafiscal.deFornec || ''}}</td>
        <td>{{notafiscal.cdFazenda}}</td>
        <td>{{notafiscal.deFazenda}}</td>
        <td><span class="text-green-700" >{{notafiscal.vlTotalNf | currency: 'BRL' : 'symbol' : '4.2-2' }}</span></td>
        <td>
          <p-calendar
            id="dataEmissaoNova"
            [(ngModel)]="notafiscal.dtEmissaoNova"
            selectionMode="single"
            dateFormat="dd/mm/yy"
            [readonlyInput]="true"
             appendTo="body"
            [style]="{'width':'10rem'}"
            [disabled]="notafiscal.nfErp > 0"/>
        </td>
        <td><input pInputText [(ngModel)]="notafiscal.cdFornecErpNova" [style]="{'width':'10rem'}" (focusout)="buscarRazaoSocial(notafiscal)" (keydown.enter)="buscarRazaoSocial(notafiscal)" [disabled]="notafiscal.nfErp > 0"/></td>
        <td>
          <p-progressSpinner styleClass="w-2rem h-2rem"
                             strokeWidth="8"
                             fill="var(--surface-ground)"
                             animationDuration=".5s"
                             *ngIf="loadingRazaoSocial" />
          <span>{{ notafiscal.deFornecErpNova || '' }}</span>
        </td>
        <td>
          <p-button icon="pi pi-check" severity="success" class="m-1" [disabled]="notafiscal.nfErp > 0" size="small" (onClick)="enviarNota(notafiscal)"></p-button>
          <p-button icon="pi pi-trash" severity="danger" class="p-button-error m-1" size="small" (onClick)="removeNota(notafiscal)"></p-button>
          <p-button icon="pi pi-download" severity="info" class="p-button-error m-1" size="small" (onClick)="exportar(notafiscal)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '35rem' }" />
  <p-confirmDialog key="notaJaEmitida" [style]="{ width: '35rem' }" />

</div>
